import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/llavero-nfc")({
  beforeLoad: () => {
    throw redirect({ href: "/llavero-nfc-qr", statusCode: 301 });
  },
});
